// extracted by mini-css-extract-plugin
export default {"warningIcon":"availability_warning_icon-module___warningIcon___acfd681e"};